<template>
	<div class="i-surveys-form-input">
		<form-item v-bind="$attrs">
			<van-field
				v-model="modelValue"
				type="textarea"
				:placeholder="placeholder"
				:rules="rules"
				:name="itemKey"
				readonly
				:autosize="{ maxHeight: 50, minHeight: 100 }"
				show-word-limit
				@click-input="clickInput"
			/>
			<van-action-sheet
				title="内容填写"
				v-model="showActionSheet"
				:close-on-click-action="false"
				@close="showActionSheet = false"
			>
				<div class="popup-content">
					<van-field
						v-model="textareaValue"
						type="textarea"
						:placeholder="placeholder"
						:readonly="isDisabled"
						:autosize="{ maxHeight: 400, minHeight: 400 }"
						class="custom-textarea"
					/>
					<div class="word-count-tip">字数要求：不低于{{ minLength }}字， <span v-if="maxLength != 0">不高于{{ maxLength }}字，</span>当前字数{{ textareaValue.length }}</div>
					<van-button block type="primary" @click.stop.prevent="clickSubmitTextarea">保存</van-button>
				</div>
			</van-action-sheet>
		</form-item>
	</div>
</template>

<script>
import FormItem from "./form-item.vue";

export default {
	components: {FormItem},
	props: {
		value: {
			type: [String, Number],
			default: "",
		},
		placeholder: {
			type: String,
			default: "",
		},
		rules: {
			type: Array,
			default: () => [],
		},
		itemKey: {
			type: String,
			default: "",
		},
		minLength: {
			type: [String, Number],
			default: 0
		},
		maxLength: {
			type: [String, Number],
			default: 99999
		}
	},
	data() {
		return {
			showActionSheet: false,
			textareaValue: "",
		};
	},
	computed: {
		modelValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val.trim());
			},
		},
		isDisabled() {
			return this.$route.query.formType === "preview";
		},
	},
	methods: {
		clickInput () {
			if (this.isDisabled) return
			this.textareaValue = this.modelValue || ""
			this.showActionSheet = true
		},
		clickSubmitTextarea () {
			const valCount = this.textareaValue?.length || 0;
			if (valCount) {
				if (this.minLength && valCount < this.minLength) return this.$toast(`内容字数不得小于${this.minLength}，当前字数${valCount}`);
				if (this.maxLength && valCount > this.maxLength) return this.$toast(`内容字数不得大于${this.maxLength}，当前字数${valCount}`);
			}
			this.showActionSheet = false
			this.modelValue = this.textareaValue
		}
	},
};
</script>

<style lang="less" scoped>
.popup-content {
	margin: 0 6px;
	padding: 12px 12px 40px;
}

.popup-title {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 16px;
}

.custom-textarea {
	min-height: 200px;
	border: 1px solid #ebedf0;
	border-radius: 4px;
	padding: 8px;
	margin-bottom: 12px;
}

.word-count-tip {
	font-size: 12px;
	color: #969799;
	margin-bottom: 16px;
	text-align: right;
}
</style>
